module.exports = __webpack_public_path__ + "img/home-9.44629a9a.webp";